export default "__VITE_ASSET__CjacUWhN__"